import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { makeStyles, Tabs as MuiTabs } from '@material-ui/core';
import clsx from 'clsx';
import { tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles(() => ({
    tabWrapper: {
        borderBottom: `1px solid ${tokens.field01}`,
    },
}));
export const Tabs = forwardRef((_a, ref) => {
    var { ariaLabel, className, value, onChange, children } = _a, otherProps = __rest(_a, ["ariaLabel", "className", "value", "onChange", "children"]);
    const classes = useStyles();
    const lastUrlSegment = window.location.pathname.split('/').pop();
    return (React.createElement(MuiTabs, Object.assign({ className: clsx(classes.tabWrapper, className), onChange: onChange, innerRef: ref, value: value || lastUrlSegment, "aria-label": ariaLabel }, otherProps), children));
});
